import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8a37e62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "squaredCalendar" }
const _hoisted_2 = {
  key: 0,
  class: "modeChanger"
}
const _hoisted_3 = { class: "navigatorContainer" }
const _hoisted_4 = { class: "navigatorTitle" }
const _hoisted_5 = {
  key: 1,
  class: "weekDaysContainer"
}
const _hoisted_6 = {
  key: 2,
  class: "weekDaysContainer"
}
const _hoisted_7 = { class: "weekDaysContainer" }
const _hoisted_8 = {
  class: "calendarDaysContainer",
  ref: "daysContainer"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_left = _resolveComponent("icon-chevron-left")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showNavigator)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.showModeChanger)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('month'))),
                  class: _normalizeClass({ active: _ctx.mode == 'month' })
                }, "VISUALIZZA MESE", 2),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('week'))),
                  class: _normalizeClass({ active: _ctx.mode == 'week' })
                }, "VISUALIZZA SETTIMANA", 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "prev",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
            }, [
              _createVNode(_component_icon_chevron_left)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.date(_ctx.currentDate, 'MMMM YYYY')), 1)
            ]),
            _createElementVNode("div", {
              class: "next",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goNext && _ctx.goNext(...args)))
            }, [
              _createVNode(_component_icon_chevron_right)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.mode == 'month')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalWeekDays, (giorno, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "weekDay",
              key: i
            }, [
              _createElementVNode("b", null, _toDisplayString(giorno), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (giorno, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "weekDay",
              key: i
            }, [
              _createElementVNode("b", null, _toDisplayString(giorno), 1)
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalWeekDays, (giorno, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "weekDay",
          key: i
        }, [
          _createElementVNode("b", {
            class: _normalizeClass({ 'text-primary': i > 4 })
          }, _toDisplayString(giorno), 3)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default", { days: _ctx.days }, () => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["calendarDay", day.classes]),
            key: i,
            onClick: ($event: any) => (_ctx.$emit('dateClick', day.date))
          }, _toDisplayString(_ctx.$filters.date(day.date, "DD")), 11, _hoisted_9))
        }), 128))
      ], true)
    ], 512)
  ]))
}